import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HOME } from "@/constants/testIds";

export default function FAQ({ items = [] }) {
  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="mx-auto max-w-[900px] px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="eyebrow">Good to know</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Frequently asked questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 md:mt-14">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={HOME.faqItem(i)}
              className="border-b hairline"
            >
              <AccordionTrigger className="font-serif-ev text-xl md:text-2xl text-left py-6 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] md:text-base leading-relaxed pb-6" style={{ color: "var(--ev-muted)" }}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
